<template>
  <div>
    <!-- debut dialog -->
    <v-dialog v-model="dialog" max-width="80%">
      <template v-slot:activator="{ on }">
        <v-layout
          class="btn-dialog"
          align-start
          justify-end
          v-show="
            $storeCommun.ListeSituationsFamiliale.filter((item) => {
              return (
                item.Supprimer == false &&
                item.Tuteur == $storeCatalogue.DataId.Oui
              );
            }).length < 3
          "
        >
          <v-btn
            dark
            v-on="on"
            v-show="!$storeCommun.ReadOnly"
            color="secondary"
            @click="AffecterAutreRevenu"
          >
            {{ $storeUm6p.Label.Ajouter }}
          </v-btn>
        </v-layout>
      </template>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>{{ $storeUm6p.Label.Ajouter }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.LienParental"
                  v-model="editedItem.Parente"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.Parente"
                  clearable
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeCommun.ReadOnly"
                  @change="parenteChange"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.SituationFamiliale"
                  v-model="editedItem.StatutParentTuteur"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.StatutParentTuteurAffiche"
                  clearable
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeCommun.ReadOnly"
                  @change="statutParentTuteurChange"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.Tuteur"
                  v-model="editedItem.Tuteur"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :clearable="!IsReadOnlyTuteur"
                  :rules="
                    editedItem.StatutParentTuteur !=
                    $storeCatalogue.SituationFamDecede
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  v-show="
                    editedItem.StatutParentTuteur !=
                    $storeCatalogue.SituationFamDecede
                  "
                  :readonly="IsReadOnlyTuteur"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.LienParenteTuteur"
                  v-show="
                    editedItem.Parente == $storeCatalogue.DataId.ParenteTuteur
                  "
                  :rules="
                    editedItem.Parente == $storeCatalogue.DataId.ParenteTuteur
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  :readonly="$storeCommun.ReadOnly"
                  :label="$storeUm6p.Label.Parents.LienParenteTuteur"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.Nom"
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeCommun.ReadOnly"
                  :label="$storeUm6p.Label.Parents.Nom"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.Prenom"
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeCommun.ReadOnly"
                  :label="$storeUm6p.Label.Parents.Prenom"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.Civilite"
                  v-model="editedItem.Civilite"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.Civilite"
                  clearable
                  :readonly="$storeCommun.ReadOnly"
                  :rules="$storeReglesBourse.obligatoire"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.Nationalite"
                  v-model="editedItem.Nationalite"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.Pays"
                  clearable
                  :readonly="$storeCommun.ReadOnly"
                  :rules="$storeReglesBourse.obligatoire"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <div
              v-show="
                editedItem.StatutParentTuteur !=
                $storeCatalogue.SituationFamDecede
              "
            >
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.Cni"
                    :label="
                      editedItem.Nationalite === $storeCommun.DataId.Maroc
                        ? $storeUm6p.Label.Parents.Cni
                        : $storeUm6p.Label.Parents.AutreCni
                    "
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :readonly="$storeCommun.ReadOnly"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"></v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.Tel"
                    :label="$storeUm6p.Label.Parents.Portable"
                    :rules="
                      Obligatoire ? $storeReglesBourse.telephoneObligatoire : []
                    "
                    :readonly="$storeCommun.ReadOnly"
                    :class="Obligatoire ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.Email"
                    :rules="
                      Obligatoire ? $storeReglesBourse.emailObligatoire : []
                    "
                    :readonly="$storeCommun.ReadOnly"
                    :label="$storeUm6p.Label.Parents.AdresseElectronique"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.TelFixe"
                    :label="$storeUm6p.Label.Parents.Fixe"
                    :readonly="$storeCommun.ReadOnly"
                    :rules="$storeReglesBourse.telephone"
                  />
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.SituationHandicap"
                    v-model="editedItem.SituationHandicap"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :readonly="$storeCommun.ReadOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                    @change="SituationHandicapChange(editedItem)"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-show="
                      editedItem.SituationHandicap == $storeCatalogue.DataId.Oui
                    "
                    :label="$storeUm6p.Label.Parents.TypeHandicap"
                    v-model="editedItem.NatureHandicap"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.NatureHandicap"
                    :rules="
                      Obligatoire &&
                      editedItem.SituationHandicap == $storeCatalogue.DataId.Oui
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    clearable
                    :readonly="$storeCommun.ReadOnly"
                    multiple
                    :class="
                      Obligatoire &&
                      editedItem.SituationHandicap == $storeCatalogue.DataId.Oui
                        ? 'asterisk'
                        : ''
                    "
                  />
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.AdressePermanente"
                    :label="$storeUm6p.Label.Parents.AdressePermanante"
                    :readonly="$storeCommun.ReadOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Candidat.PaysMaroc"
                    v-model="editedItem.Pays"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Pays"
                    :readonly="$storeCommun.ReadOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"></v-col>
              </v-row>
              <v-row v-if="editedItem.Pays == $storeCatalogue.DataId.France">
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Candidat.DepartementFrance"
                    v-model="editedItem.DepartementFrance"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.DepartementFrance"
                    clearable
                    @change="departementChange"
                    :readonly="$storeCommun.ReadOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Candidat.RegionFrance"
                    v-model="editedItem.RegionFrance"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.RegionFrance"
                    :readonly="$storeCommun.ReadOnly"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row
                v-else-if="editedItem.Pays == $storeCatalogue.DataId.Maroc"
              >
                <v-col cols="6">
                  <v-autocomplete
                    v-if="editedItem.Pays == $storeCatalogue.DataId.Maroc"
                    :label="$storeUm6p.Label.Candidat.ProvinceMaroc"
                    v-model="editedItem.ProvinceMaroc"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Province"
                    clearable
                    @change="provinceChange"
                    :readonly="$storeCommun.ReadOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-if="editedItem.Pays == $storeCatalogue.DataId.Maroc"
                    :label="$storeUm6p.Label.Candidat.RegionMaroc"
                    v-model="editedItem.RegionMaroc"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Region"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.AdresseSecondaire"
                    :label="$storeUm6p.Label.Parents.AdresseSecondaire"
                  />
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.EtatProfessionnel"
                    v-model="editedItem.SituationPro"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.SituationPro"
                    clearable
                    v-show="ShowSituationPro"
                    :rules="
                      editedItem.StatutParentTuteur !=
                        $storeCatalogue.SituationFamDecede && ShowSituationPro
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    @change="situationProChange"
                    :class="
                      editedItem.StatutParentTuteur !=
                        $storeCatalogue.SituationFamDecede && ShowSituationPro
                        ? 'asterisk'
                        : ''
                    "
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    editedItem.SituationPro ==
                    $storeCatalogue.SituationProRetraite
                    || ShowRetraiteActif
                  "
                >
                  <v-menu
                    v-model="menu.dateRetraite"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        v-model="DateRetraiteFormated"
                        :label="$storeUm6p.Label.Parents.DateDepartRetraite"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="editedItem.DateDepartRetraite = null"
                        :rules="
                          Obligatoire ? $storeReglesBourse.obligatoire : []
                        "
                        :class="Obligatoire ? 'asterisk' : ''"
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.DateDepartRetraite"
                      :min="MinDateRetraite"
                      :max="MaxDateRetraite"
                      :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                      @input="menu.dateRetraite = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if="ShowRetraiteActif">
                <v-col cols="12">
                Situation professionnelle avant la date de la retraite.
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                </v-col>
                <v-col cols="6" v-if="ShowSecteur">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Secteur"
                    v-model="editedItem.SecteurProfessionnelleRetraite"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Secteur"
                    clearable
                    @change="secteurActiviteProChange(editedItem.SecteurProfessionnelleRetraite, true)"
                    :rules="
                      Obligatoire && ShowSecteur
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowSecteur ? 'asterisk' : ''"
                  />

                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Profession"
                    v-model="editedItem.ProfessionRetraite"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Fonction"
                    v-show="ShowProfession(editedItem.SecteurProfessionnelleRetraite)"
                    clearable
                    :rules="
                      Obligatoire && ShowProfession(editedItem.SecteurProfessionnelleRetraite)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowProfession(editedItem.SecteurProfessionnelleRetraite) ? 'asterisk' : ''"
                  />

                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.EmployeurRetraite"
                    :label="$storeUm6p.Label.Parents.NomEmployeur"
                    v-show="ShowEmployeur(editedItem.SecteurProfessionnelleRetraite)"
                    :rules="
                      Obligatoire && ShowEmployeur(editedItem.SecteurProfessionnelleRetraite)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowEmployeur(editedItem.SecteurProfessionnelleRetraite) ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.TypeOrganisme"
                    v-model="editedItem.TypeOrganismeRetraite"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.TypeOrganisme"
                    :clearable="!DisableTypeOrganisme(editedItem.SecteurProfessionnelleRetraite)"
                    v-show="ShowTypeOrganisme(editedItem.SecteurProfessionnelleRetraite)"
                    :rules="
                      Obligatoire && ShowTypeOrganisme(editedItem.SecteurProfessionnelleRetraite)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowTypeOrganisme(editedItem.SecteurProfessionnelleRetraite) ? 'asterisk' : ''"
                    :readonly="DisableTypeOrganisme(editedItem.SecteurProfessionnelleRetraite)"
                  />
                </v-col>
                <v-col cols="12">
                Situation professionnelle après la date de la retraite.
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Secteur"
                    v-model="editedItem.SecteurActivitePro"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Secteur"
                    clearable
                    v-show="ShowSecteur"
                    @change="secteurActiviteProChange(editedItem.SecteurActivitePro, false)"
                    :rules="
                      Obligatoire && ShowSecteur
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowSecteur ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Profession"
                    v-model="editedItem.Profession"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Fonction"
                    v-show="ShowProfession(editedItem.SecteurActivitePro)"
                    clearable
                    :rules="
                      Obligatoire && ShowProfession(editedItem.SecteurActivitePro)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowProfession(editedItem.SecteurActivitePro) ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.Employeur"
                    :label="$storeUm6p.Label.Parents.NomEmployeur"
                    v-show="ShowEmployeur(editedItem.SecteurActivitePro)"
                    :rules="
                      Obligatoire && ShowEmployeur(editedItem.SecteurActivitePro)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowEmployeur(editedItem.SecteurActivitePro) ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.TypeOrganisme"
                    v-model="editedItem.TypeOrganisme"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.TypeOrganisme"
                    :clearable="!DisableTypeOrganisme(this.editedItem.SecteurActivitePro)"
                    v-show="ShowTypeOrganisme(editedItem.SecteurActivitePro)"
                    :rules="
                      Obligatoire && ShowTypeOrganisme(editedItem.SecteurActivitePro)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowTypeOrganisme(editedItem.SecteurActivitePro) ? 'asterisk' : ''"
                    :readonly="DisableTypeOrganisme(this.editedItem.SecteurActivitePro)"
                  />
                </v-col>
              </v-row>
              <h5 v-if="ShowAmoTadamon">
                {{ $storeUm6p.Label.Parents.AMO_TADAMON }}
              </h5>
              <v-row v-if="ShowAmoTadamon">
                <v-col cols="4">
                  <v-autocomplete
                    label=""
                    v-model="editedItem.AmoTadamon"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
              </v-row>
              <v-row
                v-show="
                  editedItem.AmoTadamon == $storeCatalogue.DataId.Non ||
                  !ShowAmoTadamon
                "
              >
                <v-col cols="6">
                  <h5>
                    {{
                      ShowAmoTadamon
                        ? $storeUm6p.Label.Parents.AutreRegimeProtection
                        : $storeUm6p.Label.Parents.RegimeProtection
                    }}
                  </h5>
                  <v-autocomplete
                    label=""
                    v-model="editedItem.AutreRegime"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="
                      editedItem.AmoTadamon == $storeCatalogue.DataId.Non &&
                      Obligatoire
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="
                      editedItem.AmoTadamon == $storeCatalogue.DataId.Non &&
                      Obligatoire
                        ? 'asterisk'
                        : ''
                    "
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-show="editedItem.AutreRegime == $storeCatalogue.DataId.Oui"
                >
                  <h5>{{ $storeUm6p.Label.Parents.QuelOrganisme }}</h5>
                  <v-text-field
                    label=""
                    v-model="editedItem.NomAutreRegime"
                    :rules="
                      Obligatoire &&
                      editedItem.AutreRegime == $storeCatalogue.DataId.Oui &&
                      editedItem.AmoTadamon == $storeCatalogue.DataId.Non
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="
                      Obligatoire &&
                      editedItem.AutreRegime == $storeCatalogue.DataId.Oui &&
                      editedItem.AmoTadamon == $storeCatalogue.DataId.Non
                        ? 'asterisk'
                        : ''
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <h5>{{ $storeUm6p.Label.Parents.BeneficiaireAssurance }}</h5>
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Mutuelle"
                    v-model="editedItem.Mutuelle"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    clearable
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"></v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.NombreCompteBancaire"
                    v-model="editedItem.NombreCompteBancaire"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.NbCompteBancaire"
                    clearable
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <h5>
                    {{ $storeUm6p.Label.Parents.AssocieOuGerantSociete }}
                  </h5>
                  <v-autocomplete
                    label=" "
                    v-model="editedItem.AssocieGerant"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-show="
                    editedItem.AssocieGerant == $storeCatalogue.DataId.Oui
                  "
                >
                  <h5>
                    {{ $storeUm6p.Label.Parents.PreciserSociete }}
                  </h5>
                  <v-text-field
                    label=""
                    v-model="editedItem.PreciserSociete"
                    :rules="
                      editedItem.AssocieGerant == $storeCatalogue.DataId.Oui
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="
                      editedItem.AssocieGerant == $storeCatalogue.DataId.Oui
                        ? 'asterisk'
                        : ''
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small dark color="secondary" @click="close">{{
              $storeUm6p.Label.Annuler
            }}</v-btn>
            <v-btn small dark color="secondary" @click="save">{{
              $storeUm6p.Label.Valider
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- fin dialog -->
    <!-- Début Liste langues -->
    <v-data-table
      :headers="headers"
      :items="$storeCommun.ListeSituationsFamiliale"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.Supprimer">
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Parente,
                item.Parente,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.OuiNon,
                item.Tuteur,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.StatutParentTuteurAffiche,
                item.StatutParentTuteur,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">{{ item.Nom }}</th>
          <th class="text-xs-left">{{ item.Prenom }}</th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.SituationPro,
                item.SituationPro,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Secteur,
                item.SecteurActivitePro,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Fonction,
                item.Profession,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-show="!$storeCommun.ReadOnly"
              >{{ icons.mdiPencil }}</v-icon
            >
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="!$storeCommun.ReadOnly"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
import { mdiPencil, mdiDelete } from "@mdi/js";
export default {
  components: {},
  data() {
    return {
      menu: {
        dateRetraite: false,
      },
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeCommun: this.$storeCommun,
      // dialog pour ouvrir/fermer la popup
      dialog: false,
      // Validation du formulaire
      valid: false,

      // nom des colonnes
      headers: [
        { text: "Parenté", value: "parente" },
        { text: "Tuteur(rice)", value: "tuteur" },
        { text: "Situation familiale", value: "situationfamiliale" },
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        // { text: "Numéro CNI", value: "numcni" },
        // { text: "Tel", value: "tel" },
        // { text: "Email", value: "email" },
        { text: "Situation professionelle", value: "situationpro" },
        { text: "Secteur d'activité professionel", value: "secteuractpro" },
        { text: "Profession", value: "profession" },
        // { text: "Employeur", value: "employeur" },
        // { text: "Situation de handicap", value: "situationhandicap" },
        // { text: "Type de handicap", value: "naturehandicap" },
        { text: "", value: "actions", sortable: false },
      ],

      // index de l'objet édité.
      editedIndex: -1,

      // Item local
      editedItem: {
        CandidatureBourseFirsi: null,
        CandidatureBourseId: null,
        Index: null,
        Supprimer: false,
        IdCrypte: null,
        Parente: null,
        Tuteur: null,
        StatutParentTuteur: null,
        LienParenteTuteur: null,
        Nom: null,
        Prenom: null,
        Civilite: null,
        Nationalite: null,
        Cni: null,
        Tel: null,
        Email: null,
        Pays: null,
        RegionMaroc: null,
        ProvinceMaroc: null,
        RegionFrance: null,
        DepartementFrance: null,
        SituationPro: null,
        DateDepartRetraite: null,
        SecteurActivitePro: null,
        Profession: null,
        Employeur: null,
        SituationHandicap: null,
        NatureHandicap: null,
        Mutuelle: null,
        TypeOrganisme: null,
        IdCrypteRevenus: null,
        RevenuMensuelNet: null,
        RevenuNetImposableDgi: null,
        RevenuNetAnnuelAttestation: null,
        RevenuNetMensuelAttestation: null,
        RevenuNetMensuelBulletinPaie: null,
        RevenuNetMensuelBulletinPaieDecembre: null,
        AutreRevenuNetAnnuel: null,
        SommeNetMensuelAttestationPension: null,
        AllocationsFamiliales: null,
        NetMensuelPensionMere: null,
        ProfitsEtrangersCaHt: null,
        ProfitsEtrangersNetImposable: null,
        ProfitsEtrangersEmployeur: null,
        CapitauxMobiliersCaHt: null,
        CapitauxMobiliersNetImposable: null,
        CapitauxMobiliersEmployeur: null,
        FonciersCaHt: null,
        FonciersNetImposable: null,
        FonciersEmployeur: null,
        SalariauxEtAssimilesCaHt: null,
        SalariauxEtAssimilesNetImposable: null,
        SalariauxEtAssimilesEmployeur: null,
        AgricolesCaHt: null,
        AgricolesNetImposable: null,
        AgricolesEmployeur: null,
        ProfessionnelsCaHt: null,
        ProfessionnelsNetImposable: null,
        ProfessionnelsEmployeur: null,
        TelFixe: null,
        AdressePermanente: null,
        AdresseSecondaire: null,
        AmoTadamon: null,
        AutreRegime: null,
        NomAutreRegime: null,
        NombreCompteBancaire: null,
        AssocieGerant: null,
        PreciserSociete: null,
        AutreRevenuDto: {
          RevenuAgricole: null,
          RevenuLocatifNet: null,
          Dividendes: null,
          AutresRevenus: null,
          ProduitVenteBien: null,
          Heritage: null,
          AutresRevenusExceptionnels: null,
          NatureRevenus: null,
          NatureRevenusExceptionnels: null,
        },
        ListeBiensImmo: [],
        ListeCredits: [],
        ListeAnnexesFirsi: [],
      },
    };
  },
  computed: {
    Obligatoire() {
      return (
        this.editedItem.StatutParentTuteur !=
        this.$storeCatalogue.SituationFamDecede
      );
    },
    ShowAmoTadamon() {
      return (
        this.editedItem.Nationalite === this.$storeCommun.DataId.Maroc &&
        this.editedItem.SecteurActivitePro !=
          this.$storeCatalogue.SecteurSalarie &&
        this.editedItem.SecteurActivitePro !=
          this.$storeCatalogue.SecteurFonctionnaire &&
        this.editedItem.SituationPro !=
          this.$storeCatalogue.SituationProRetraite
      );
    },
    ShowSecteur() {
      return !(
        this.editedItem.SituationPro ==
          this.$storeCatalogue.SituationProNonActif ||
        (this.editedItem.StatutParentTuteur ==
          this.$storeCatalogue.SituationFamDivorce &&
          this.editedItem.Tuteur == this.$storeCatalogue.DataId.Non)
      );
    },
    ShowSituationPro() {
      return !(
        this.editedItem.StatutParentTuteur ==
          this.$storeCatalogue.SituationFamDivorce &&
        this.editedItem.Tuteur == this.$storeCatalogue.DataId.Non
      );
    },
    ShowRetraiteActif(){
      return (this.editedItem.SituationPro === this.$storeCatalogue.DataId.SituationProRetraiteActif);
    },
    DateRetraiteFormated() {
      return this.formatDate(this.editedItem.DateDepartRetraite);
    },
    IsReadOnlyTuteur() {
      return (
        ((this.editedItem.Parente == this.$storeCatalogue.DataId.ParenteMere ||
          this.editedItem.Parente == this.$storeCatalogue.DataId.ParentePere) &&
          this.editedItem.StatutParentTuteur ==
            this.$storeCatalogue.SituationFamMarie) ||
        this.$storeCommun.ReadOnly
      );
    },
    MinDateRetraite() {
      return moment(String(new Date()))
        .subtract(70, "year")
        .format("YYYY-MM-DD");
    },
    MaxDateRetraite() {
      return moment(String(new Date())).format("YYYY-MM-DD");
    },
  },
  methods: {
    SituationHandicapChange(item){
        if(item.SituationHandicap === this.$storeCatalogue.DataId.Non){
            item.NatureHandicap = [];
        }
    },
    AffecterAutreRevenu() {
      this.editedItem.AutreRevenuDto.SituationFamiliale =
        this.editedItem.IdCrypte;
      this.editedItem.AutreRevenuDto.CandidatureBourse =
        this.$storeDemandeBourse.DonneesFormulaire.EncryptId;
      this.editedItem.AutreRevenuDto.CandidatureBourseFirsi = this.$storeUm6p.Formulaire.Id;
      this.editedItem.AutreRevenuDto.FinancementPropriete =
        this.$storeCatalogue.DataId.AutreRevenu;
      this.editedItem.AutreRevenuDto.PersonneConcernee =
        this.$storeCatalogue.PersonneConcerne(this.editedItem.Parente);
    },
    editItem(item) {
      // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
      this.editedIndex =
        this.$storeCommun.ListeSituationsFamiliale.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.AffecterAutreRevenu();
      // ouvre le popup
      this.dialog = true;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        // on récupère l'item depuis le store
        this.editedIndex =
          this.$storeCommun.ListeSituationsFamiliale.indexOf(item);
        // on affecte l'item local pour récupèrer les valeurs
        this.editedItem = Object.assign({}, item);

        // on affecte la valeur supprimer à true
        this.editedItem.Supprimer = true;

        // on modifie l'item dans le store
        Object.assign(
          this.$storeCommun.ListeSituationsFamiliale[this.editedIndex],
          this.editedItem
        );
        // appel le close pour désaffecter l'item local
        this.RazEditedItem();
      }
    },
    RazEditedItem() {
      // on remet à zéro le editedItem local
      this.editedItem = Object.assign(
        {},
        {
          CandidatureBourseFirsi: null,
          CandidatureBourseId: null,
          Index: null,
          Supprimer: false,
          IdCrypte: null,
          Parente: null,
          Tuteur: null,
          StatutParentTuteur: null,
          LienParenteTuteur: null,
          Nom: null,
          Prenom: null,
          Civilite: null,
          Nationalite: null,
          Cni: null,
          Tel: null,
          Email: null,
          Pays: null,
          RegionMaroc: null,
          ProvinceMaroc: null,
          RegionFrance: null,
          DepartementFrance: null,
          SituationPro: null,
          SecteurActivitePro: null,
          Profession: null,
          Employeur: null,
          SituationHandicap: null,
          NatureHandicap: null,
          Mutuelle: null,
          TypeOrganisme: null,
          RevenuMensuelNet: null,
          RevenuNetImposableDgi: null,
          RevenuNetAnnuelAttestation: null,
          RevenuNetMensuelAttestation: null,
          RevenuNetMensuelBulletinPaie: null,
          RevenuNetMensuelBulletinPaieDecembre: null,
          AutreRevenuNetAnnuel: null,
          SommeNetMensuelAttestationPension: null,
          AllocationsFamiliales: null,
          NetMensuelPensionMere: null,
          ProfitsEtrangersCaHt: null,
          ProfitsEtrangersNetImposable: null,
          ProfitsEtrangersEmployeur: null,
          CapitauxMobiliersCaHt: null,
          CapitauxMobiliersNetImposable: null,
          CapitauxMobiliersEmployeur: null,
          FonciersCaHt: null,
          FonciersNetImposable: null,
          FonciersEmployeur: null,
          SalariauxEtAssimilesCaHt: null,
          SalariauxEtAssimilesNetImposable: null,
          SalariauxEtAssimilesEmployeur: null,
          AgricolesCaHt: null,
          AgricolesNetImposable: null,
          AgricolesEmployeur: null,
          ProfessionnelsCaHt: null,
          ProfessionnelsNetImposable: null,
          ProfessionnelsEmployeur: null,
          TelFixe: null,
          AdressePermanente: null,
          AdresseSecondaire: null,
          AmoTadamon: null,
          AutreRegime: null,
          NomAutreRegime: null,
          NombreCompteBancaire: null,
          AssocieGerant: null,
          PreciserSociete: null,
          AutreRevenuDto: {
            Supprimer: false,
            PersonneConcernee: null,
            FinancementPropriete: null,
            CandidatureBourse: null,
            SituationFamiliale: null,
            IdCrypte: null,
            RevenuAgricole: null,
            RevenuLocatifNet: null,
            Dividendes: null,
            AutresRevenus: null,
            ProduitVenteBien: null,
            Heritage: null,
            AutresRevenusExceptionnels: null,
            NatureRevenus: null,
            NatureRevenusExceptionnels: null,
          },
          ListeBiensImmo: [],
          ListeCredits: [],
          ListeAnnexesFirsi: [],
        }
      );
      this.editedIndex = -1;

      this.$storeCommun.CountNombreTuteurs(this.$storeCommun.ListeSituationsFamiliale);
    },
    close() {
      // RAZ des champs du formulaire
      this.$refs.form.resetValidation();

      // ferme le popup
      this.dialog = false;

      this.RazEditedItem();

      this.editedIndex = -1;
    },
    save() {
      // validation du formulaire
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }

      // on passe le item local à false.
      this.editedItem.Supprimer = false;

      this.AffecterAutreRevenu();

      // on modifie l'item dans le store si l'editedIndex est renseigné.
      if (this.editedIndex > -1) {
        Object.assign(
          this.$storeCommun.ListeSituationsFamiliale[this.editedIndex],
          this.editedItem
        );
      }
      // sinon, on ajoute l'item local au store.
      else {
        let index = this.$storeCommun.ListeSituationsFamiliale.length + 1;
        this.editedItem.Index = index;

        this.$storeCommun.ListeSituationsFamiliale.push(this.editedItem);
      }
      this.$storeCommun.CountNombreTuteurs(this.$storeCommun.ListeSituationsFamiliale);

      // on appelle close pour raz l'item local + fermer le popup
      this.close();
    },

    // méthodes on change
    provinceChange() {
      this.editedItem.RegionMaroc = this.$storeCatalogue.GetParentId(
        this.$storeCatalogue.Province,
        this.editedItem.ProvinceMaroc
      );
    },

    departementChange() {
      this.editedItem.RegionFrance = this.$storeCatalogue.GetParentId(
        this.$storeCatalogue.DepartementFrance,
        this.editedItem.DepartementFrance
      );
    },
    parenteChange() {
      if (
        this.editedItem.Parente != this.$storeCatalogue.DataId.ParenteTuteur
      ) {
        this.editedItem.StatutParentTuteur = "";
        this.$storeCatalogue.StatutParentTuteurAffiche =
          this.$storeCatalogue.GetByCode(
            this.$storeCatalogue.StatutParentTuteur,
            "P"
          );
      } else {
        this.$storeCatalogue.StatutParentTuteurAffiche =
          this.$storeCatalogue.StatutParentTuteur;
      }
    },
    statutParentTuteurChange() {
      if (
        this.editedItem.StatutParentTuteur ==
        this.$storeCatalogue.SituationFamDecede
      ) {
        this.editedItem.Tuteur = null;
      }
      if (
        this.editedItem.StatutParentTuteur ==
        this.$storeCatalogue.SituationFamMarie
      ) {
        this.editedItem.Tuteur = this.$storeCatalogue.DataId.Oui;
      }
    },
    DisableTypeOrganisme(secteurActivite){
      if (secteurActivite == this.$storeCatalogue.SecteurFonctionnaire) {
        return true;
      } 
      else if (secteurActivite == this.$storeCatalogue.SecteurSalarie) {
        return true;
      } 
      else {
        return false;
      }
    },
    secteurActiviteProChange(secteur, retraite) {
      if (secteur == this.$storeCatalogue.SecteurFonctionnaire
      ) {
        if(retraite){
          this.editedItem.TypeOrganismeRetraite = this.$storeCatalogue.DataId.TypeOrganismePublic;
        }
        else{
          this.editedItem.TypeOrganisme = this.$storeCatalogue.DataId.TypeOrganismePublic;
        }
      } 
      else if (secteur == this.$storeCatalogue.SecteurSalarie) {
        if(retraite){
          this.editedItem.TypeOrganismeRetraite = this.$storeCatalogue.DataId.TypeOrganismePrive;
        }
        else{
          this.editedItem.TypeOrganisme = this.$storeCatalogue.DataId.TypeOrganismePrive;
        }
      }
    },
    situationProChange() {
      this.editedItem.TypeOrganisme = null;
      this.editedItem.SecteurActivitePro = null;
      this.editedItem.Employeur = null;
      this.editedItem.Profession = null;
      this.editedItem.TypeOrganismeRetraite = null;
      this.editedItem.SecteurActiviteProRetraite = null;
      this.editedItem.EmployeurRetraite = null;
      this.editedItem.ProfessionRetraite = null;
    },
    
    ShowEmployeur(secteurActivite) {
      return (
        !(
          this.editedItem.SituationPro == this.$storeCatalogue.SituationProNonActif ||
          secteurActivite == this.$storeCatalogue.SecteurLiberale ||
          secteurActivite == this.$storeCatalogue.SecteurAutoEntrepreneur ||
          (this.editedItem.StatutParentTuteur == this.$storeCatalogue.SituationFamDivorce &&
            this.editedItem.Tuteur == this.$storeCatalogue.DataId.Non)
        ) &&
        !(
          this.editedItem.Tuteur == this.$storeCatalogue.DataId.Oui &&
          secteurActivite == this.$storeCatalogue.SecteurAgricole
        ) &&
        !(
          this.editedItem.Tuteur == this.$storeCatalogue.DataId.Oui &&
          secteurActivite == this.$storeCatalogue.SecteurInformel
        )
      );
    },
    ShowTypeOrganisme(secteurActivite) {
      return (
        (secteurActivite ==
          this.$storeCatalogue.SecteurFonctionnaire ||
        secteurActivite ==
          this.$storeCatalogue.SecteurSalarie)
          && this.editedItem.Tuteur != this.$storeCatalogue.DataId.Non
      );
    },
    ShowProfession(secteurActivite) {
      return (
        !(
          this.editedItem.SituationPro ==
            this.$storeCatalogue.SituationProNonActif ||
          (this.editedItem.StatutParentTuteur ==
            this.$storeCatalogue.SituationFamDivorce &&
            this.editedItem.Tuteur == this.$storeCatalogue.DataId.Non)
        ) &&
        !(
          this.editedItem.Tuteur == this.$storeCatalogue.DataId.Oui &&
          secteurActivite == this.$storeCatalogue.SecteurAgricole
        )
      );
    },
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
